import { render, staticRenderFns } from "./OtherComp.vue?vue&type=template&id=34b6f7a8&scoped=true&"
import script from "./OtherComp.vue?vue&type=script&lang=ts&"
export * from "./OtherComp.vue?vue&type=script&lang=ts&"
import style0 from "./OtherComp.vue?vue&type=style&index=0&id=34b6f7a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b6f7a8",
  null
  
)

export default component.exports